import { Link } from 'react-router-dom';
import type { Movie } from '@/mocks/movies';

interface MovieCardProps {
  movie: Movie;
  size?: 'default' | 'small';
}

export default function MovieCard({ movie, size = 'default' }: MovieCardProps) {
  const isSmall = size === 'small';

  return (
    <Link
      to={`/article/${movie.id}`}
      className="group block no-underline cursor-pointer"
    >
      <div
        className={`relative overflow-hidden rounded-lg bg-background-100 transition-all duration-300 group-hover:scale-[1.02] ${
          isSmall ? 'aspect-[3/4]' : 'aspect-[2/3]'
        }`}
      >
        <img
          src={movie.posterImage}
          alt={`${movie.title} - 蚂蚁影视高清免费在线观看`}
          title={`${movie.title} - 蚂蚁影视高清免费在线观看`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-110"
          loading="lazy"
        />

        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent" />

        {movie.tags && movie.tags.length > 0 && (
          <div className="absolute top-2 left-2 flex flex-wrap gap-1">
            {movie.tags.map((tag) => (
              <span
                key={tag}
                className={`px-1.5 py-0.5 text-[10px] font-medium rounded whitespace-nowrap ${
                  tag === '热播'
                    ? 'bg-primary-500 text-background-50'
                    : tag === '新片' || tag === '新剧' || tag === '新番' || tag === '新季'
                    ? 'bg-accent-500 text-background-50'
                    : 'bg-background-50/20 text-background-50 backdrop-blur-sm'
                }`}
              >
                {tag}
              </span>
            ))}
          </div>
        )}

        <div className="absolute bottom-0 left-0 right-0 p-3">
          <h3
            className={`font-semibold text-background-50 line-clamp-2 leading-tight ${
              isSmall ? 'text-xs' : 'text-sm'
            }`}
          >
            {movie.title}
          </h3>
          <div className="flex items-center gap-2 mt-1.5">
            <span className="text-xs text-accent-400 font-medium">
              {movie.rating}
            </span>
            <span className="text-[10px] text-background-50/60">
              {movie.year}
            </span>
            {!isSmall && (
              <span className="text-[10px] text-background-50/60">
                {movie.duration}
              </span>
            )}
          </div>
        </div>
      </div>
    </Link>
  );
}